import React from "react";

interface CausesListProps {
  filteredCauses: Record<string, number>;
}

const CausesList: React.FC<CausesListProps> = ({ filteredCauses }) => {
  const hasCauses = filteredCauses && Object.keys(filteredCauses).length > 0;
  return (
    <>
      <div className="select-component__duration-section">
        {hasCauses ? (
          <>
            <div className="causes-list">
              {Object.entries(filteredCauses)
                .sort(([, countA], [, countB]) => countB - countA)
                .slice(0, 3)
                .map(([cause, count], index) => (
                  <div key={cause} className="cause-item">
                    {/* Cause name */}
                    <span className="cause-name">{cause}</span>

                    {/* Count as a badge */}
                    <span className="cause-badge">{count}</span>
                  </div>
                ))}
            </div>
          </>
        ) : (
          <>
            <h3 className="top-causes-title">You have not added any causes</h3>
          </>
        )}
      </div>
    </>
  );
};

export default CausesList;
